import React from 'react';
import clsx from 'clsx';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import Logo from '@/components/Logo';
import TimeFormat from '@/components/TimeFormat';


const useStyles = makeStyles(theme => ({
  container: {
    marginBottom: 10
  },
  divider:{
    flexGrow: 1,
  },
  item: {
    border: '1px solid #000',
    borderRadius: 5,
    padding: '0 10px 0 0',
    [theme.breakpoints.down('sm')]: {
      margin: '8px 0 0',
      width: '100%',
    },
  },
  padding: {
    padding: 10,
  }
}))

function GameEventHeader({ period, time, team, type }) {
  const classes = useStyles();
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'));
  return (
    <Grid container className={classes.container}>
      <Grid item className={clsx(classes.item, { [classes.padding]: !team })}>
        <Grid container alignItems="center" justify={isMobile ? "center" : undefined}>
          {team && (
            <Grid item>
              <Logo size={3} id={team} />
            </Grid>
          )}
          <Grid item>
            <Typography variant="body2" component="span">
              {team && "-"} {type}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <div className={classes.divider} />
      { time && period && (
        <Grid
          item
          className={clsx(classes.item, classes.padding)}
          justify={isMobile ? "center" : undefined}
        >
          <Grid container item alignItems="center" justify={isMobile ? "center" : undefined}>
            <Typography variant="caption">
              <TimeFormat time={time} /> / {period}
            </Typography>
          </Grid>
        </Grid>
      )}
    </Grid>
  )
}

export default GameEventHeader;
